import { render } from "./ContactModule.vue?vue&type=template&id=9513f330&scoped=true"
import script from "./ContactModule.vue?vue&type=script&lang=js"
export * from "./ContactModule.vue?vue&type=script&lang=js"

import "./ContactModule.vue?vue&type=style&index=0&id=9513f330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9513f330"]])

export default __exports__